import { show, hide } from 'redux-modal'
import { replace } from 'connected-react-router'
import { addVehicle } from 'actions/addVehicle'
import { navigateToSearchByVehicle } from 'actions/shopByVehicle'
import {
  ADD_VEHICLE_MODAL,
  CONFIRM_TIRE_SIZE_MODAL,
  STORE_LOCATOR_MODAL_PAGE
} from 'constant'
import { getActiveVehicle, getPageLocation } from 'selectors'
import { getCompatibilityParameter } from '../helpers'
import { updateSortByPrice } from './helpers'

export const handleVehicleAdd = () => (dispatch, getState) =>
  dispatch(show(ADD_VEHICLE_MODAL, {
    confirmTireSizeModalProps: {
      async handleTiresSelect({
        vehicle,
        frontTireSize,
        rearTireSize,
        loadIndex,
        rearLoadIndex,
        speedRating,
        rearSpeedRating
      }) {
        await dispatch(
          addVehicle({
            ...vehicle,
            loadIndex,
            rearLoadIndex,
            speedRating,
            rearSpeedRating,
            tireFrontSize: frontTireSize,
            tireRearSize: rearTireSize
          })
        )
        dispatch(hide(CONFIRM_TIRE_SIZE_MODAL))

        // TODO implement compatible tire lines check once BE provides API (https://tbccorp.atlassian.net/browse/DPW-6377)
        const hasCompatibleTireLines = true

        if (hasCompatibleTireLines) {
          const { search, ...location } = getPageLocation(getState())
          const compatibilityParameter = getCompatibilityParameter()
          const updatedSearch = search ?
            `${search}&${compatibilityParameter}` :
            `?${compatibilityParameter}`

          return dispatch(replace({
            ...location,
            search: updatedSearch
          }))
        }

        dispatch(navigateToSearchByVehicle({ vehicle, frontTireSize, rearTireSize }))
      }
    }
  }))

export const handleTiresSearch = () => (dispatch, getState) => {
  const vehicle = getActiveVehicle(getState())

  dispatch(navigateToSearchByVehicle(vehicle))
}

export const handleStoreSearch = () => show(STORE_LOCATOR_MODAL_PAGE)

export const updateSortByPriceQuery = (value) => (dispatch, getState) => {
  const { search, ...location } = getPageLocation(getState())

  dispatch(replace({
    ...location,
    search: updateSortByPrice(search, value)
  }))
}
